import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './modules/auth'
import chat from './modules/chat'
import settings from './modules/settings'
import ecommerce from './modules/ecommerce'
import mail from './modules/mail'
import cart from './cart'
import crud from './crud'
import config from '@/config'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    menuItems: config.menuItems,
    loading: true,
    error: null,
    isError: null // Only required to inform App.vue that an error is there hence initiate the snackbar
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    }
  },
  mutations: {
    categories (state, payload) {
      state.categories = payload
    },
    settings (state, payload) {
      state.settings = payload
    },
    setWarning (state, msg) {
      state.error = {}
      state.error = { is: true, msg, time: Date.now(), type: 2, duration: 3 }
    },
    setErr (state, msg) {
      state.error = {}
      state.error = { is: true, msg, time: Date.now(), type: 3, duration: 3 }
    },
    setInfo (state, msg) {
      state.error = {}
      state.error = { is: true, msg, time: Date.now(), type: 4, duration: 2 }
    },
    clearError (state) {
      state.error = { is: false, msg: '', time: Date.now(), type: 3, duration: 0 }
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setSuccess (state, err) {
      state.isError = Date.now()
      state.error = err.message
    },
    setError (state, err) {
      state.isError = Date.now()
      if (!err) return
      state.loading = false
      err = err.response || err
      if (err.status === 403) {
        state.error = 'Please login to continue'
        window.localStorage.setItem('authUser', JSON.stringify({}))
        state.user = {}
        state.token_id = null
      } else if (err.status === 404) {
        state.error = 'The requested resource not found'
      } else if (err.status > 499) {
        state.error = 'Server connection refused'
      } else if (err.statusText) {
        state.error = err.statusText
      }
    },
    errWithMessage (state, err) {
      state.isError = Date.now()
      if (err) {
        err = err.message
        state.loading = false
      }
    },
    setMessage (state, msg) {
      state.isError = Date.now()
      // state.error = null // Clear any previous error first
      state.loading = false
      state.error = msg
    }
  },
  modules: {
    auth,
    chat,
    settings,
    ecommerce,
    mail,
    cart,
    crud
  }
})
